export const planningAssitantCategory = Object.freeze({
  LOCATION: 'location',
  LOKALER: 'Lokaler',
  RESOURCES: 'resources',
  INVITEES: 'invitees',
});
